var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1562 2C16.6866 2 17.1952 2.21063 17.5702 2.58557C17.9452 2.96063 18.1558 3.46924 18.1558 3.99957C18.1558 4.5299 17.9452 5.03852 17.5702 5.41357L9.98425 12.9996H7.15625V10.1716L14.7423 2.58557C15.1173 2.21063 15.6259 2 16.1562 2ZM2.74204 4.58579C2.36696 4.96086 2.15625 5.46957 2.15625 6V16C2.15625 16.5304 2.36696 17.0391 2.74204 17.4142C3.11711 17.7893 3.62582 18 4.15625 18H14.1562C14.6867 18 15.1954 17.7893 15.5705 17.4142C15.9455 17.0391 16.1562 16.5304 16.1562 16V12C16.1562 11.7348 16.0509 11.4804 15.8634 11.2929C15.6758 11.1054 15.4215 11 15.1562 11C14.891 11 14.6367 11.1054 14.4491 11.2929C14.2616 11.4804 14.1562 11.7348 14.1562 12V16H4.15625V6H8.15625C8.42147 6 8.67582 5.89464 8.86336 5.70711C9.05089 5.51957 9.15625 5.26522 9.15625 5C9.15625 4.73478 9.05089 4.48043 8.86336 4.29289C8.67582 4.10536 8.42147 4 8.15625 4H4.15625C3.62582 4 3.11711 4.21071 2.74204 4.58579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/editWhite.5858c587ee1bf274fc6654adaeb3ed4c.svg";
export { ForwardRef as ReactComponent };